import { ReactSVG } from 'react-svg';
import { COLORS, fontSizes } from '../../constants/constants';
import { iconColor } from '../../utils/functions';
import Footer from '../Footer';
import TopHeader from '../TopHeader';
import ViewItems from '../ViewItems';
import ViewReverse from '../ViewReverse';
import { Text } from '../SecondaryMarket';
import ContainerFunctional from './index.function';
import icons from '../../constants/icons';
import { cn } from '../../utils/utils';

const Container = ({ title, children, className, isBack = true, isPublic, handleLogout, onLogoutPress }) => {
  const { TextWeight, navigate, accountOpeningData, isArabic, getContentKey } = ContainerFunctional();

  if (!isPublic) {
    if (!accountOpeningData || accountOpeningData == {}) {
      const redirect_url = `${process.env.REACT_APP_OPEN_ACCOUNT_LINK}${isArabic ? 'ar' : 'en'}`;
      window.location.href = redirect_url;
    }
  }

  return (
    <div className='flex flex-col min-h-screen max-h-screen'>
      <TopHeader handleLogout={handleLogout} onLogoutPress={onLogoutPress} />
      <div className='flex flex-col flex-1 overflow-y-auto'>
        {title && (
          <ViewItems className={'px-8 md:px-20 lg:px-36 py-8 bg-dark-blue gap-4 justify-center h-36'}>
            {isBack && (
              <ViewReverse className={'items-center gap-3 cursor-pointer'} onClick={() => navigate(-1)}>
                <ReactSVG src={icons.back} beforeInjection={(svg) => iconColor(svg, COLORS.white)} />
                <Text text={getContentKey('back')} className={'text-white/90 mt-0.5'} />
              </ViewReverse>
            )}

            <Text text={title} weight={TextWeight.headingRegular} size={fontSizes.h30} className={'text-white'} />
          </ViewItems>
        )}
        <div className={cn('flex flex-col flex-1 px-4 md:px-12 pt-8 pb-4 bg-background', className)}>
          <div className='flex-1 flex flex-col mb-10'>{children}</div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Container;
